import { render, staticRenderFns } from "./hhyf-duanwu.vue?vue&type=template&id=a6361b2a&scoped=true"
import script from "./hhyf-duanwu.vue?vue&type=script&lang=js"
export * from "./hhyf-duanwu.vue?vue&type=script&lang=js"
import style0 from "./hhyf-duanwu.vue?vue&type=style&index=0&id=a6361b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6361b2a",
  null
  
)

export default component.exports